import { React, useState, useEffect } from "react";

const PopUpAndarBaharResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let Andar = "";
    let Bahar = "";

    if (marketType == 24) {
        if (resultData?.result == 2) {
            Andar = "Winner";
            Bahar = "LOSER";
        } else if (resultData?.result == 1) {
            Andar = "LOSER";
            Bahar = "Winner";
        }
    }

    const AndarBaharcards = resultData?.cards_desc?.split(",") || [];
    const andarCards = AndarBaharcards.filter((_, i) => i % 2 === 0);
    const baharCards = AndarBaharcards.filter((_, i) => i % 2 !== 0);



    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">
                    <div id="andar-bahar" style={{ display: marketType == 24 ? "" : "none" }}>
                        <div class="card">
                            <div class="card-header">
                                Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div
                                        class="col-12 col-md-12"
                                        style={{ margin: "auto", textAlign: "center" }}
                                    >
                                        <div class="player-item">
                                            <b>
                                                <span class="name" style={{ color: "#000" }}>Community Cards</span>
                                            </b>
                                            <div class="player-card community-card">
                                                <div
                                                    id="BFBCardHandView"
                                                    class="BFBCardHandViewDealerab"
                                                >
                                                    <div id="BFBCardFanView" style={{ flexWrap: "wrap" }}>
                                                        <div class="RSMImageView2ab">
                                                            <img
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "50px",
                                                                    height: "auto", alignItems: "center"
                                                                }}
                                                                src={`/assets/images/cards/${resultData.j1}.svg`}
                                                                class="img"
                                                            />
                                                            {/*<img style="width:100%; max-width:50px; height:auto;" src="/img/Cards/card_simple_35.svg">*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div
                                        class="col-12 col-md-6"
                                        style={{ margin: "auto", textAlign: "center" }}
                                    >
                                        <div class="player-item">
                                            <b>
                                                <span class="name" style={{ color: "#000" }}>Andar</span>
                                            </b>
                                            <div class="player-card">
                                                <div
                                                    id="BFBCardHandView"
                                                    class="BFBCardHandViewDealerab"
                                                >
                                                    <div >
                                                        <div class="RSMImageView2ab">
                                                            <div className="andarColumn">
                                                                {andarCards.map((card, i) => (
                                                                    <img
                                                                        key={i}
                                                                        src={`/assets/images/cards/${card}.svg`}
                                                                        style={{
                                                                            width: "100%",
                                                                            maxWidth: "50px",
                                                                            height: "auto"
                                                                        }}
                                                                    />
                                                                ))}
                                                            </div>
                                                            {/*<img style={{ width: "100%", maxWidth: "50px", height: "auto" }} src={`/assets/images/cards/${resultData.c1}.svg`} class="img" />
                              <img style="width:100%; max-width:50px; height:auto;" src="/img/Cards/card_simple_33.svg">*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-12 col-md-6"
                                        style={{ margin: "auto", textAlign: "center" }}
                                    >
                                        <div class="player-item">
                                            <b>
                                                <span class="name" style={{ color: "#000" }}>Bahar</span>
                                            </b>
                                            <div class="player-card">
                                                <div
                                                    id="BFBCardHandView"
                                                    class="BFBCardHandViewDealerab"
                                                >
                                                    <div >
                                                        <div className="baharColumn">
                                                            {baharCards.map((card, i) => (
                                                                <img
                                                                    key={i}
                                                                    src={`/assets/images/cards/${card}.svg`}
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: "50px",
                                                                        height: "auto"
                                                                    }}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="ExMainCardbundle"
                                    style={{ textAlign: "-webkit-center" }}
                                >
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Andar
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{Andar}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Bahar
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{Bahar}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <style>
                {`

        .andarColumn,
        .baharColumn {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start !important;
            align-items: flex-start !important;
            gap: 5px;
        }

        .andarColumn img,
        .baharColumn img {
            display: block;
            margin: 0 !important;
        }

        /* Player card container */
        .player-card {
            width: 100%;
            box-sizing: border-box;
            border: 1px solid rgba(255, 255, 255, 0.12);
            border-radius: 16px;
            padding: 2px 7px 2px;
            background: transparent;
            backdrop-filter: blur(1px);
            text-align: left !important;
        }

        /* Make the card area itself left aligned */
        .player-card .BFBCardHandViewDealerab {
            width: 100%;
            text-align: left !important;
        }

        .player-card .RSMImageView2ab {
            width: 100%;
            text-align: left !important;
        }

        .ExMainCardbundle {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
        }

        .ExMainCardbundle .market-runners {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .ExMainCardbundle .runner-runner {
            width: 100%;
            min-height: 65px;
            margin-top: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            text-align: center;
        }

        .ExMainCardbundle .runner-name {
            width: 100%;
            margin: 0;
            padding: 0;
            text-align: center;
        }

        .ExMainCardbundle .runner-info {
            width: 100%;
            text-align: center;
        }

        .ExMainCardbundle .runner-display-name {
            width: 100%;
            display: block;
            text-align: center;
        }

        .ExMainCardbundle .clippable-spacer {
            width: 100%;
            margin: 0;
            padding: 0;
            text-align: center;
            font-size: 30px;
            font-weight: 700;
        }

        .ExMainCardbundle .runner-disabled {
            width: 100%;
            line-height: 35px;
            margin: 0;
            padding: 0;
            color: #000;
            background: transparent;
            text-align: center;
            text-transform: uppercase;
            font-size: 15px;
        }
        .community-card {
            text-align: center !important;
        }

        .community-card .BFBCardHandViewDealerab {
            width: 100%;
            text-align: center !important;
        }

        .community-card #BFBCardFanView {
            width: 100%;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
        }

        .community-card .RSMImageView2ab {
            display: flex;
            justify-content: center !important;
            align-items: center !important;
        }
    `}
            </style>
        </div>
    );
};

export default PopUpAndarBaharResults;

